<template>
    <div v-if="propSelectValues!=null" class="input-unit mb-4">
        <select class="custom-select" @change="changeBranche()" v-model="selectionRelationId">
            <option v-if="selectionRelationId == 0" value="0">{{ $translate("Woerner::Template.chooseBranche") }}</option>
            <option v-for="option in propSelectValues" :value="option.id">
                {{ option.relation.relationValues[0].value }}
            </option>
        </select>
        <label v-if="currentuserpropname != null">
            {{ currentuserpropname }}
        </label>
    </div>
</template>

<script>
    export default
    {
        props:
        {
            template:
            {
                type: String,
                default: "#vue-prop-select"
            },
            propid:
            {
                type:Number,
                default:0
            },
            user:
            {
                type:Object,
                default:null
            },
            currentuserpropname:
            {
                type:String,
                default:null
            }
        },
        data: function()
        {
            return {
                propSelectValues:null,
                loading:false,
                userProps:null,
                selectionRelationId:0,
                foundPropIdChangeId:0
            }
        },
        mounted()
        {
            if(this.propid != 0)
            {
                this.getCustomerSelectedValue(this.propid);
                //console.log('mounted');
            }
        },
        methods:
            {
                changeBranche()
                {
                    // target = user,
                    // $selectedid = ausgewählter wert
                    // $proprelationid


                    // NO Branch selected in past / POST NEW VALUE
                    if(this.foundPropIdChangeId==0)
                    {
                        let dataobj =
                        {
                            "targetid":this.user.id,
                            "selectedid":this.selectionRelationId,
                            "propertyid":this.propid
                        }
                        $.ajax(
                    {
                            type: 'POST',
                            data: dataobj,
                            url: '/customerprops/selectset/set/'+ App.language + '/',
                            success: function (response)
                            {
                                //console.log(response);
                            },
                            error: function (jqXHR) {
                                // console.log(jqXHR);
                            }
                        });
                    }
                    else
                    {
                        // Just Change Branch for a Misstage
                        let dataobj =
                        {
                            "targetid":this.user.id,
                            "proprelationid":this.foundPropIdChangeId,
                            "selectedid":this.selectionRelationId,
                            "propertyid":this.propid
                        }
                        $.ajax(
                    {
                            type: 'POST',
                            data: dataobj,
                            url: '/customerprops/selectset/update/' + App.language + '/',
                            success: function (response)
                            {
                                //console.log(response);
                            },
                            error: function (jqXHR) {
                                // console.log(jqXHR);
                            }
                        });
                    }

                },
                getCustomerSelectedValue (propid)
                {
                    let _self = this;
                    let dataobj =
                        {
                            "id"         : propid,
                            "contactid"  : this.user.id
                        }
                    $.ajax(
                {
                        type: 'POST',
                        data:dataobj,
                        url: '/customerprops/select/' + App.language + '/',
                        success: function (response)
                        {

                            if(response.all.length > 1)
                            {
                                _self.propSelectValues = [];

                                for(let i = 0; i < response.all.length; i++)
                                {
                                    for(let n = 0; n < response.all[i].length; n++)
                                    {
                                        _self.propSelectValues.push(response.all[i][n]);
                                    }
                                }
                                for (let i = 0; i < response.contact.length; i++)
                                {
                                    if(response.contact[i].propertyId == propid)
                                    {
                                        _self.selectionRelationId         = response.contact[i].selectionRelationId;
                                        _self.foundPropIdChangeId         = response.contact[i].id;
                                    }
                                }
                                _self.userProps = response.contact;
                            }
                            else
                            {
                                _self.propSelectValues = response.all[0];
                                _self.userProps = response.contact;
                                for (let i = 0; i < response.contact.length; i++)
                                {
                                    if(response.contact[i].propertyId == propid)
                                    {
                                        _self.selectionRelationId         = response.contact[i].selectionRelationId;
                                        _self.foundPropIdChangeId = response.contact[i].id;
                                    }
                                }
                            }
                        },
                        error: function (jqXHR) {
                            // console.log(jqXHR);
                        }
                    });

                },
                removeUnwanted()
                {

                }
            },

        computed:
            {
                shipping:function()
                {
                    return 'lala'
                }
            }
    }
</script>
